<template>
  <v-container>
    <ChangeUserPassword ref="change-password-student" />

    <v-menu v-model="menu" open-on-hover offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <v-avatar :class="{ 'mr-4': !isXsScreen, 'mr-n6': isXsScreen }" size="32">
            <v-img :src="avatar" />
          </v-avatar>
          <div class="d-none d-sm-flex">{{ user.student.name || 'Học sinh' }}</div>
        </v-btn>
      </template>
      <v-card v-if="user.student">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ user.student.name || 'Học sinh' }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.student.code || '--' }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-btn text @click="changePassword(user._id)">Thay đổi mật khẩu</v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn text @click="signOut()">Đăng xuất</v-btn>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import ChangeUserPassword from '../../../modules/staff/ChangeUserPassword.vue'
export default {
  data() {
    return { menu: null }
  },
  components: {
    ChangeUserPassword
  },
  computed: {
    ...mapGetters('auth', ['user', 'profile']),
    avatar() {
      return get(this.user, 'student.avatar.url', '/default-avatar.svg')
    },
    isXsScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    signOut() {
      if (this.$snapshot.validate()) {
        this.$store.dispatch('app/reset')
        this.$store.dispatch('auth/signOut')
      }
    },
    async changePassword(userId) {
      this.$refs['change-password-student'].openDialog(userId)
    }
  }
}
</script>

<style scoped></style>
